export default "__VITE_ASSET__D36Mz6Eb__"